import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./ChatGptLoader.Style";

const ChatGptLoader = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Box className={classes.LoaderMainBox}>
      <Box className={classes.ImageBox}>
        <Box>
          {/* <img className={classes.ImageDiv} src={NewChatGptLoader} /> */}
          <Box>
            <Typography className={classes.TypoDiv} variant='h4bold'>
              {t("chatgpt_reload_message1")}
            </Typography>
            <Typography variant='h5regular' className={classes.TypoDiv2}>
              {t("chatgpt_reload_message2")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatGptLoader;
